import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, FormControl, ControlLabel} from "react-bootstrap";
import {TopButtonAdd} from "../../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";


export default class DefinicjaGodzinyStartowejDodawanieForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kalendarz_wybrany: null,
            godzina_wybrana: '',
            validatorMessages: []
        };
        this.onChangeNowyKalendarz = this.onChangeNowyKalendarz.bind(this)
        this.onChangeNowaGodzina = this.onChangeNowaGodzina.bind(this)
        this.onClickDodaj = this.onClickDodaj.bind(this)

    }

    componentDidMount() {
        if (this.props.kalendarzId) {
            let kalendarz = this.props.kalendarze.find(k => k.idRk === this.props.kalendarzId);
            if (Boolean(kalendarz)) {
                this.setState({kalendarz_wybrany: kalendarz})
            }
        }
    }

    componentWillReceiveProps(nextprops){
        if(Boolean(nextprops)){
            let kalendarz = this.props.kalendarze.find(k => k.idRk === nextprops.kalendarzId);
            if (Boolean(kalendarz)) {
                this.setState({kalendarz_wybrany: kalendarz})
            }
        }
    }

    onChangeNowyKalendarz(e) {
        this.setState({kalendarz_wybrany: e})
    }

    onChangeNowaGodzina(e) {
        this.setState({godzina_wybrana: e.target.value})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickDodaj() {
        let poprawne = true;
        this.state.validatorMessages = []

        if (!Boolean(this.state.kalendarz_wybrany)) {
            this.dodajDoValidatorMessages('Nie wybrano kalendarza')
            poprawne = false;
        }

        if (!Boolean(this.state.godzina_wybrana)) {
            this.dodajDoValidatorMessages('Nie wybrano godziny')
            poprawne = false;
        }
        if (poprawne) {
            this.setState({validatorMessages: []})

            let data = {
                "godz1p": parseFloat((this.state.godzina_wybrana).replace(':', '.')),
                "idRk": this.state.kalendarz_wybrany.idRk,
                "idTr": this.props.trasaId,
                "zmiana": null,
                "idEk": null
            }

            this.props.handleClickDodaj(data)

            document.getElementById('InputNowaGodzina' + this.props.kalendarzId).value = '';
        }
    }

    render() {

        return (
            <Col sm={12}>
                <Row>
                    <Col xs={12} md={8} mdOffset={4} lg={6} lgOffset={6}>
                        <div style={{marginTop: '15px'}}>
                            <Form horizontal={true}>
                                <FormGroup>
                                    <Col xs={12} sm={6} lg={4}>
                                            <div>
                                                <ControlLabel>Rodzaj kalendarza</ControlLabel>
                                                <TopSelect onChange={this.onChangeNowyKalendarz}
                                                           value={this.state.kalendarz_wybrany}
                                                           options={this.props.kalendarze}
                                                           valueKey={'idRk'}
                                                           labelKey={'nazRk'}
                                                           disabled={Boolean(this.props.kalendarzId)}
                                                />
                                            </div>
                                    </Col>
                                    <Col xs={12} sm={6} lg={4}>
                                        <ControlLabel>Godzina</ControlLabel>
                                        <FormControl type={'time'} onChange={this.onChangeNowaGodzina}
                                                     id={'InputNowaGodzina' + this.props.kalendarzId}/>
                                    </Col>
                                    <Col xs={12} sm={6} lg={4}>
                                        <div className={'add-label-margin'}></div>
                                        <TopButtonAdd onClick={this.onClickDodaj} text={'Dodaj godzinę'}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <ValidatorMessages messages={this.state.validatorMessages}/>
                                </FormGroup>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Col>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/definicjeGodzinStartowychjDlaTrasy/components/DefinicjaGodzinyStartowejDodawanieForm.js